import React from "react";
import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  StopOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import type { BundleResponse, DataExportStatus } from "@/types";

export type BundleStatus = DataExportStatus | "Expired";

export const isExpired = (bundle: BundleResponse) => {
  const expiresAt = bundle.expires_at;
  if (!expiresAt) return false;
  return Date.parse(expiresAt) < Date.now();
};

export const resolveUiStatus = (bundle: BundleResponse): BundleStatus => {
  if (
    bundle.status === "Completed" &&
    (isExpired(bundle) || !bundle.download_url)
  ) {
    return "Expired";
  }
  return bundle.status;
};

type Visual = {
  icon: React.ReactNode;
  color: string;
  i18nKey: string;
};

export const getBundleStatusVisual = (status: BundleStatus): Visual => {
  switch (status) {
    case "Pending":
      return {
        icon: React.createElement(ClockCircleOutlined),
        color: "default",
        i18nKey: "media.organizations.dataExport.status.pending",
      };
    case "Running":
      return {
        icon: React.createElement(SyncOutlined, { spin: true }),
        color: "processing",
        i18nKey: "media.organizations.dataExport.status.running",
      };
    case "Completed":
      return {
        icon: React.createElement(CheckCircleOutlined),
        color: "success",
        i18nKey: "media.organizations.dataExport.status.completed",
      };
    case "Failed":
      return {
        icon: React.createElement(CloseCircleOutlined),
        color: "red",
        i18nKey: "media.organizations.dataExport.status.failed",
      };
    case "Expired":
      return {
        icon: React.createElement(StopOutlined),
        color: "default",
        i18nKey: "media.organizations.dataExport.status.expired",
      };
  }
};
